import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// GET /api/v1/saas/limits/
// → { headquarters: {allowed, limit, used, suggest_upgrade}, teachers: {...}, students: {...} }
function usePlanLimits() {
  return useQuery({
    queryKey: ["plan-limits"],
    queryFn: () => apiClient.get("/api/v1/saas/limits/").then((r) => r.data),
    staleTime: 60_000,
  });
}

export { usePlanLimits };
